import { makeAutoObservable } from 'mobx';
import { OptionCategory } from '../model/professional/option-category-model';

class CategoryStore {
  // État des catégories
  categories: OptionCategory[] = [];
  isLoading = false;
  error: string | null = null;
  
  // État du service parent sélectionné
  selectedServiceId: string | null = null;
  
  constructor() {
    makeAutoObservable(this);
  }
  
  /**
   * Méthodes pour accéder aux données
   */
  getCategoryById(categoryId: string): OptionCategory | undefined {
    return this.categories.find(category => category.id === categoryId);
  }
  
  /**
   * Méthode pour définir les catégories dans le store
   */
  setCategories(categories: OptionCategory[]) {
    this.categories = categories;
  }
  
  /**
   * Méthode pour définir le service parent sélectionné
   */
  setSelectedServiceId(serviceId: string | null) {
    this.selectedServiceId = serviceId;
  }
  
  /**
   * Méthodes pour gérer l'état de chargement
   */
  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  
  /**
   * Méthode pour gérer les erreurs
   */
  setError(error: string | null) {
    this.error = error;
  }
  
  /**
   * Méthode pour ajouter une catégorie au store
   */
  addCategory(category: OptionCategory) {
    const existingIndex = this.categories.findIndex(c => c.id === category.id);
    if (existingIndex >= 0) {
      // Mise à jour d'une catégorie existante
      this.categories[existingIndex] = category;
    } else {
      // Ajout d'une nouvelle catégorie
      this.categories.push(category);
    }
  }
  
  /**
   * Méthode pour mettre à jour une catégorie dans le store
   */
  updateCategoryInStore(categoryId: string, updatedCategory: Partial<OptionCategory>) {
    const index = this.categories.findIndex(c => c.id === categoryId);
    if (index >= 0) {
      this.categories[index] = { ...this.categories[index], ...updatedCategory };
    }
  }
  
  /**
   * Méthode pour supprimer une catégorie du store
   */
  removeCategoryFromStore(categoryId: string) {
    this.categories = this.categories.filter(c => c.id !== categoryId);
  }
  
  /**
   * Méthode pour obtenir toutes les catégories d'un service
   */
  getCategoriesByServiceId(serviceId: string): OptionCategory[] {
    const filteredCategories = this.categories.filter(category => category.serviceId === serviceId);
    return filteredCategories;
  }
}

const categoryStore = new CategoryStore();
export default categoryStore;
